import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, Layout } from "antd";
import {
  BookOutlined,
  BarsOutlined,
  CarryOutOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import MuseumOutlinedIcon from '@mui/icons-material/MuseumOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { obtenerAccesosPorUsuario } from "../services/access.service";
import "./SideMenu.css";
import { ACCESOS, USERID } from "../config/constants";
import { useAuth } from "../hooks";
import { STRINGS } from "../dictionaries/ESP.dictionary";

const { Sider } = Layout;

const SideMenu = ({ menuCollapsed }) => {
  const { logout, user } = useAuth();
  const location = useLocation();
  const [current, setCurrent] = useState(location.pathname);
  const currentUserid = localStorage.getItem(USERID);
  const [accVisializarAbm, setaccVisualizarAbm] = useState(false);
  const [accVisializarHomologarUsu, setaccVisualizarHomologarUsu] = useState(false);
  const [accAbmUsu, setAccAbmUsu] = useState(false);    
  const [accAbmTiTra, setAccAbmTiTra] = useState(false);  
  const [accAbmReq, setAccAbmReq] = useState(false);  
  const [accAbmOfi, setAccAbmOfi] = useState(false);  
  const [menuItemsArr, setMenuItemsArr] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga
  const navigate = useNavigate();

  useEffect(() => {
    setCurrent(location.pathname);
  }, [location.pathname]);

  const handleLogout = async () => {
    const result = await logout();

    if (result === true) {
      window.location.href = "/";
    } else {
      window.location.href = "/";
    }
  };

  const handleLinkMunicipio = async () => {
    window.open("https://www.moron.gob.ar/", "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const fetchAccesos = async () => {
      try {
        setLoading(true);
        const response = await obtenerAccesosPorUsuario(currentUserid);
        const accAbmUsu = response.data.data?.some(acceso => acceso.acceso.trim().toUpperCase() === ACCESOS.ABM_USUARIOS);    
        const accAbmTiTra = response.data.data?.some(acceso => acceso.acceso.trim().toUpperCase() === ACCESOS.ABM_TIPOS_TRAMITE); 
        const accAbmReq = response.data.data?.some(acceso => acceso.acceso.trim().toUpperCase() === ACCESOS.ABM_REQUISITOS); 
        const accAbmOfi = response.data.data?.some(acceso => acceso.acceso.trim().toUpperCase() === ACCESOS.ABM_OFICINAS); 
        const accHomo = response.data.data?.some(acceso => acceso.acceso.trim().toUpperCase() === ACCESOS.USUARIO_HOMOLOGAR);    
        setAccAbmUsu(accAbmUsu);
        setAccAbmTiTra(accAbmTiTra);
        setAccAbmReq(accAbmReq);
        setAccAbmOfi(accAbmOfi);
        setaccVisualizarAbm(accAbmUsu || accAbmTiTra || accAbmReq || accAbmOfi);
        setaccVisualizarHomologarUsu(accHomo);
      } catch (error) {
        console.error("Error al obtener accesos del usuario", error);
      } finally {
        setLoading(false); // Desactivar la carga después de obtener los accesos
      }
    };

    fetchAccesos();
  }, [currentUserid]);

  useEffect(() => {
    if (!user || loading) return; // No generar el menú hasta que el usuario y accesos estén listos

    const abmMenu = {
      key: "/abm",
      icon: <BookOutlined />,
      label: "ABM",
      children: [
      ],
    };

    if(accAbmUsu){
      abmMenu.children.push({
        key: "/usuarios",
        icon: <GroupOutlinedIcon />,
        label: STRINGS.USERS,
      });
    }
    
    if(accAbmOfi){
      abmMenu.children.push(    {
        key: "/oficinas",
        icon: <BusinessOutlinedIcon />,
        label: STRINGS.OFFICES,
      });
    }
    if(accAbmTiTra){
      abmMenu.children.push({
        key: "/tiposDeExpediente",
        icon: <BookOutlined />,
        label: "Trámites",
      });
    }


    if(accAbmReq){
      abmMenu.children.push({
        key: "/requisitos",
        icon: <CarryOutOutlined />,
        label: "Requisitos",
      });
    }

    const abmMenuHomo = {
      key: "/abm",
      icon: <BookOutlined />,
      label: "ABM",
      children: [
        {
          key: "/homologar",
          icon: <GroupOutlinedIcon />,
          label: STRINGS.HOMO,
        }
      ],
    };

    let finalMenu = [];

    switch (user.id_tipo_us) {
      case 0:
        finalMenu = [
          {
            key: "/",
            icon: <BarsOutlined />,
            label: STRINGS.CASES,
          },
          ...(accVisializarAbm ? [abmMenu] : []),
          ...(accVisializarHomologarUsu && !accVisializarAbm? [abmMenuHomo] : []),
          {
            key: "",
            icon: <AccountBalanceOutlinedIcon />,
            label: (
              <a 
                href="https://www.moron.gob.ar/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Municipio
              </a>
            ),
          },
          {
            key: "/logout",
            icon: <LogoutOutlined />,
            label: STRINGS.LOGOUT,
            onClick: handleLogout,
          },
        ];
        break;

      case 1:
        finalMenu = [
          {
            key: "/",
            icon: <BarsOutlined />,
            label: STRINGS.MY_PROCEDURE,
          },
          {
            key: "",
            icon: <AccountBalanceOutlinedIcon />,
            label: (
              <a 
                href="https://www.moron.gob.ar/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Municipio
              </a>
            ),
          },          
          {
            key: "/logout",
            icon: <LogoutOutlined />,
            label: STRINGS.LOGOUT,
            onClick: handleLogout,
          },
        ];
        break;

      case 2:
        finalMenu = [
          {
            key: "/",
            icon: <BarsOutlined />,
            label: STRINGS.MY_PROCEDURE,
          },
          {
            key: "",
            icon: <AccountBalanceOutlinedIcon />,
            label: (
              <a 
                href="https://www.moron.gob.ar/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Municipio
              </a>
            ),
          },         
          {
            key: "/logout",
            icon: <LogoutOutlined />,
            label: STRINGS.LOGOUT,
            onClick: handleLogout,
          },
        ];
        break;

      default:
        finalMenu = [];
    }

    setMenuItemsArr(finalMenu);
  }, [user?.id_tipo_us, accVisializarAbm, accAbmUsu, accAbmTiTra, accAbmReq, accAbmOfi, accVisializarHomologarUsu, loading]); // Asegurarse de que dependa de 'loading'

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
  };

  if (loading) {
    return null; // Mostrar null o un loader mientras los datos están cargando
  }

  return (
    <Sider className="admin-sider" collapsed={menuCollapsed}>
      <Menu
        className="menu"
        mode="inline"
        onClick={onClick}
        defaultSelectedKeys={current}
        style={{ backgroundColor: "#fff", fontSize: 16 }}
        items={menuItemsArr}
      />
    </Sider>
  );
};

export default SideMenu;
